import {
  Palette as CreativeIcon,
  Article as ContentIcon,
  PhotoCamera as MediaIcon,
  Code as DevelopmentIcon,
  DesignServices as DesignIcon,
  Science as SpecializedIcon,
  SmartToy as GeneralIcon,
  Restaurant as CulinaryIcon,
  AutoStories as StorytellingIcon,
  Checkroom as FashionIcon,
} from '@mui/icons-material';
import { agentConfigs } from './agentConfig';

export interface AgentCategory {
  id: string;
  name: string;
  icon: React.ComponentType<any>;
  description: string;
  agents: typeof agentConfigs;
}

export const agentCategories: AgentCategory[] = [
  {
    id: 'creative-studios',
    name: 'Creative Studios',
    icon: CreativeIcon,
    description: 'Multi-agent workflows for complex creative projects',
    agents: agentConfigs.filter(agent =>
      ['prompt-evolution', 'fashion-design-studio'].includes(agent.id)
    ),
  },
  {
    id: 'content-creation',
    name: 'Content Creation',
    icon: ContentIcon,
    description: 'Tools for articles, blogs, journalism, and marketing content',
    agents: agentConfigs.filter(agent =>
      ['blog-multi-agent', 'journalism-multi-agent',
       'social-media'].includes(agent.id)
    ),
  },
  {
    id: 'writing-storytelling',
    name: 'Writing & Storytelling',
    icon: StorytellingIcon,
    description: 'Novel writing, screenplay, storyboarding, comics, and narrative creation',
    agents: agentConfigs.filter(agent =>
      ['novel-writing', 'screenplay', 'comic-book', 'storyboard'].includes(agent.id)
    ),
  },
  {
    id: 'image-video',
    name: 'Image & Video',
    icon: MediaIcon,
    description: 'Image and video generation, prompt refinement, and visual content tools',
    agents: agentConfigs.filter(agent =>
      ['image-prompt', 'image-generation', 'video-prompt'].includes(agent.id)
    ),
  },
  // {
  //   id: 'development-tech',
  //   name: 'Development & Tech',
  //   icon: DevelopmentIcon,
  //   description: 'Coding, documentation, and data analysis tools',
  //   agents: agentConfigs.filter(agent => 
  //     ['incubation', 'code-improvement', 'tech-doc-multi-agent', 'data-analysis', 
  //      'simple-data', 'ragtag'].includes(agent.id)
  //   ),
  // },
  {
    id: 'creative-fashion',
    name: 'Creative Fashion',
    icon: FashionIcon,
    description: 'Fashion design and collection creation tools',
    agents: agentConfigs.filter(agent =>
      ['fashion-multi-agent', 'fashion-design-studio', 'fashion-design-gallery'].includes(agent.id)
    ),
  },
  // {
  //   id: 'creative-culinary',
  //   name: 'Creative Culinary',
  //   icon: CulinaryIcon,
  //   description: 'Cuisine-specific AI agents and culinary creativity tools',
  //   agents: agentConfigs.filter(agent =>
  //     ['cuisine-prompt-studio'].includes(agent.id)
  //   ),
  // },
  // {
  //   id: 'specialized-domains',
  //   name: 'Specialized Domains',
  //   icon: SpecializedIcon,
  //   description: 'Niche and specialized AI agents',
  //   agents: agentConfigs.filter(agent => 
  //     ['niche-agents', 'scientific', 'paleontology'].includes(agent.id)
  //   ),
  // },
  // {
  //   id: 'general-ai',
  //   name: 'General AI Tools',
  //   icon: GeneralIcon,
  //   description: 'General purpose AI assistants',
  //   agents: agentConfigs.filter(agent => 
  //     ['chat', 'abstract-thinker'].includes(agent.id)
  //   ),
  // },
];

export const getCategoryById = (id: string): AgentCategory | undefined => {
  return agentCategories.find(category => category.id === id);
};

export const getCategoryByAgentId = (agentId: string): AgentCategory | undefined => {
  return agentCategories.find(category => 
    category.agents.some(agent => agent.id === agentId)
  );
};